export default __webpack_public_path__ + "static/MIRROR SHIELD LAMINATE-bcdd054c4d87270a55d180a86513a226.webp";